export default "__VITE_ASSET__y6Rzd8IP__"